/** @jsxImportSource @emotion/react */
import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import { trim } from 'ramda'
import React from 'react'

import { Tags } from '../../presentation/Tag'
import FlexGrid from '../../structure/FlexGrid'
import Input from '../Input'

const TagsInput = ({ value, onChange, breakpoints, ...props }) => {
  value = value || []
  breakpoints = breakpoints || []
  const [localValue, setLocalValue] = React.useState('')

  const style = css`
    text-transform: none;
    min-height: 2.5rem;
    display: flex;
    align-items: center;
    width: 100%;
    border-radius: 5px;
    border: 1px solid ${COLORS.dark4};
    background-color: transparent;
    position: relative;
    box-shadow: none;
    width: 100%;
    -webkit-appearance: none;
    padding: 0.1rem ${!!value.length ? 0.5 : 0}rem;
    width: 100%;
  `

  const onInsertTag = newValue => {
    if (!!trim(newValue)) {
      onChange([...value, newValue])
      setLocalValue('')
    }
  }

  const onRemoveTag = index => {
    onChange(value.filter((v, i) => i !== index))
  }

  const handleKeyDown = e => {
    if ((breakpoints || []).includes(e.key)) {
      onInsertTag(localValue)
      setTimeout(() => setLocalValue(''), 1)
    }
    if (!localValue && e.key === 'Backspace') {
      onRemoveTag(value.length - 1)
    }
  }

  return (
    <div css={style}>
      <FlexGrid justify="stretch" align="flex-start" flex={1}>
        <Tags values={value} gutter={0.1} onRemove={onRemoveTag}>
          <Input
            minWidth="8rem"
            noBorder
            value={localValue}
            onChange={setLocalValue}
            onKeyPress={onInsertTag}
            onKeyDown={handleKeyDown}
            onBlur={onInsertTag}
            {...props}
          />
        </Tags>
      </FlexGrid>
    </div>
  )
}

export default TagsInput
